import { render, staticRenderFns } from "./DayWiseStudentAssigment.vue?vue&type=template&id=47ba5349&"
import script from "./DayWiseStudentAssigment.vue?vue&type=script&lang=js&"
export * from "./DayWiseStudentAssigment.vue?vue&type=script&lang=js&"
import style0 from "./DayWiseStudentAssigment.vue?vue&type=style&index=0&id=47ba5349&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports